import TopicListingCard from './TopicListingCard';
import { CardTitle } from './styled';

export default function TopicListingCardCover(props) {
  const { tagsDetails } = props;
  return tagsDetails?.map((element, index) => {
    return (
      <div key={`card_${index}`}>
        <CardTitle>{element?.description}</CardTitle>

        <TopicListingCard
          title={element?.description}
          cardData={element?.childTagsDetails}
        />
      </div>
    );
  });
}
